import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  ClipboardList,
  FilePlus,
  BarChart2,
  Brain,
  CheckCircle,
  FileText,
} from "lucide-react";

// Divider component
const Divider = () => (
  <hr className="border-t-2 border-[#FF4D00] max-w-6xl w-full mx-auto my-12 opacity-60" />
);

const FeaturesPage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const features = [
    {
      title: "Domain-Based Assessments",
      icon: <ClipboardList className="w-10 h-10 text-[#FF4D00]" />,
      description:
        "Easily navigate assessments structured around COBIT 2019 governance domains or BCM business continuity domains.",
    },
    {
      title: "Evidence Upload",
      icon: <FilePlus className="w-10 h-10 text-[#FF4D00]" />,
      description:
        "Attach supporting documents and descriptions directly within each question to provide justification and audit readiness.",
    },
    {
      title: "Auto-Generated Reports",
      icon: <BarChart2 className="w-10 h-10 text-[#FF4D00]" />,
      description:
        "Receive comprehensive reports immediately after completing an assessment, including visual analysis of maturity or continuity capabilities.",
    },
    {
      title: "Maturity & Readiness Scoring",
      icon: <Brain className="w-10 h-10 text-[#FF4D00]" />,
      description:
        "Automatically calculate and assign maturity levels (COBIT) or readiness levels (BCM) based on responses provided.",
    },
    {
      title: "Progress Tracking",
      icon: <CheckCircle className="w-10 h-10 text-[#FF4D00]" />,
      description:
        "Track completion status for each domain or process with visual indicators, so you always know what’s done and what still needs attention.",
    },
    {
      title: "PDF Export",
      icon: <FileText className="w-10 h-10 text-[#FF4D00]" />,
      description:
        "Export finalized reports to professional PDF documents for sharing with stakeholders, auditors, or executive teams.",
    },
  ];

  return (
    <div className="min-h-screen bg-white text-gray-800">
      <Helmet>
        <title>Features | Governance & Continuity Tool</title>
      </Helmet>

      {/* Features Section */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-10" data-aos="fade-down">
            Key Features
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
            {features.map((feature, index) => (
              <div
                key={index}
                className="border p-6 rounded-lg shadow hover:shadow-lg"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="mb-4">{feature.icon}</div>
                <h4 className="text-xl font-semibold mb-2">{feature.title}</h4>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Divider />
    </div>
  );
};

export default FeaturesPage;
